import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MultiSelectInputComponent } from '../../kit/input/multi-select-input-v2/multi-select-input.component';
import { UserChipComponent } from '../../kit/user-chip/user-chip.component';
import { FormatPersonPipe } from '../../../modules/shared/pipes/format-person.pipe';
import { UserSelectStore } from '../user-select/user-select.store';
import { UserSelectBase } from '../user-select/user-select.base';

@Component({
    selector: 'app-users-select',
    templateUrl: './users-select.component.html',
    styleUrls: ['./users-select.component.scss'],
    providers: [UserSelectStore],
    imports: [
        FormatPersonPipe,
        MultiSelectInputComponent,
        TranslatePipe,
        UserChipComponent,
    ],
})
export class UsersSelectComponent extends UserSelectBase<string[]> {

    public showClear = input(true);
    public appendTo = input<'body' | HTMLElement>('body');
    public zIndex = input<number | null>(null);
    public selectedUsersDisplayLimit = input(2);

}
